import React, {useContext} from "react";
import Image1 from "../../assets/images/hotal-1.png";
import BadgeIcon from "../../assets/images/icons/aroplane-bed.svg";
import BadgeIconDark from "../../assets/images/icons/aroplane-bed-dark.svg";
import "./style.scss";
import {
    getCurrencyBadge,
} from "../../helpers/common";
import { getWebLinkFilters } from "../../utils/webShareLink";
import AppConfig from "../../helpers/config";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
    faMapMarkerAlt,
    faStar,
    faChevronUp,
    faChevronDown,
} from "@fortawesome/pro-solid-svg-icons";
import {
    Accordion,
    AccordionContext,
    useAccordionButton,
} from "react-bootstrap";
import FavoriteAccordionWebLink from "../FavoriteAccordion/FavoriteAccordionWebLink";
import PropTypes from "prop-types";
import useTranslationCustom from "../../i18n/customHook/useTranslation";

// Parallel Web Link version of ListViewCardBranch. Same UI/styling/structure, but
// consumes the FLAT decoded share data (see src/utils/webShareLink.js). The Branch
// card is left untouched.
const HotelItemWebLink = ({offer}) => {
    const {T} = useTranslationCustom();
    const currency = offer?.currency || "$";
    const filters = getWebLinkFilters(offer, T);

    const isUrl = offer?.airlineCode;

    function ContextAwareToggle({eventKey, callback}) {
        const {activeEventKey} = useContext(AccordionContext);

        const decoratedOnClick = useAccordionButton(
            eventKey,
            () => callback && callback(eventKey)
        );

        const isCurrentEventKey = activeEventKey === eventKey;

        return (
            <button type="button" className={"action-btn"} onClick={decoratedOnClick}>
                {isCurrentEventKey ? T("Buttons:View_Less") : T("Buttons:View_More")}{" "}
                <FontAwesomeIcon
                    icon={isCurrentEventKey ? faChevronUp : faChevronDown}
                />
            </button>
        );
    }

    ContextAwareToggle.propTypes = {
        eventKey: PropTypes.string.isRequired,
        callback: PropTypes.func,
    };

    const handleOnClick = () => {
        // !offer?.detailsLink &&
        // navigateToDetailPage(
        //     offer,
        //     dispatch,
        //     loginconfig,
        //     searchfilters,
        //     navigate,
        //     "hotel"
        // )
    }

    return (
        <>
            <Accordion>
                <div className="packages-card-list" onClick={() => handleOnClick()}>
                    <div className="list-card-image-holder">
                        <img
                            src={offer?.image || Image1}
                            className="covered-image"
                            alt={"hotel-image"}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleOnClick();
                            }}
                        />
                        <div className="card-badge">
                            <img src={BadgeIcon} alt={"badge-icon"}/>
                            <span>{T("Home:Home_Hotel_Incl_Flight")}</span>
                        </div>
                    </div>
                    <div className="list-card-content-holder">
                        <div className="list-card-content-Body">
                            <h4 className="heading heading-6 dark-text font-poppings ellipis">
                                {offer?.name}
                            </h4>
                            <div className="reviews">
                                <div className="star">
                                    {[1, 2, 3, 4, 5].map((item, index) => {
                                        if (item <= Number(offer?.starRating))
                                            return (
                                                <FontAwesomeIcon
                                                    key={index}
                                                    icon={faStar}
                                                    className="filled"
                                                />
                                            );
                                        else
                                            return (
                                                <FontAwesomeIcon
                                                    key={index}
                                                    icon={faStar}
                                                    className="blank"
                                                />
                                            );
                                    })}
                                    <span>{offer?.guestRatingReviewText}</span>
                                </div>
                            </div>
                            <p className="location">
                                <FontAwesomeIcon icon={faMapMarkerAlt}/>
                                {offer?.address}
                            </p>
                            <ul className="info-tags">
                                {filters?.map((filter, index) => {
                                    return (
                                        <li
                                            className="veryLight-bg fs-12 medium darkgray-color"
                                            key={index}
                                        >
                                            {filter.title}
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                        <div className="list-card-pricing">
                            <div className="logo-holder">
                                {isUrl && (
                                    <img
                                        src={AppConfig.getAirlineImageURL(isUrl)}
                                        alt={"card-logo"}
                                    />
                                )}
                                <p>
                                    <img src={BadgeIconDark} alt={"badge-icon"}/>{" "}
                                    {T("Home:Home_Hotel_Incl_Flight").toLowerCase()}
                                </p>
                            </div>
                            <div className="price-holder">
                                <div className="price">
                                    {getCurrencyBadge(currency)}
                                    {offer?.perPersonPrice && (
                                        <PriceBoxes
                                            price={Number(
                                                offer?.perPersonPrice
                                            ).toFixed(0)}
                                        />
                                    )}
                                </div>
                                <p className="price-caption">{T("Home:Home_List_View_Total_Text")}</p>

                            </div>
                        </div>
                    </div>
                </div>
                <FavoriteAccordionWebLink offer={offer} isBranched={true}/>
            </Accordion>
        </>
    );
}

const PriceBoxes = ({price}) => {
    let value = price.toString().split("");
    let valueIndex = 0;
    let _price = [];
    for (let index = 0; index <= value.length; index++) {
        if (value.length && value[value.length - valueIndex]) {
            _price.unshift(value[value.length - valueIndex]);
        }
        valueIndex++;
    }

    return _price.map((digit, index) => <span key={index}>{digit}</span>);
};

PriceBoxes.propTypes = {
    price: PropTypes.string,
};

HotelItemWebLink.propTypes = {
    offer: PropTypes.object,
    index: PropTypes.number,
    handler: PropTypes.func
};

export default HotelItemWebLink;
